/**
 * Boxful Fulfillment 2026 home page - page shell: init, drawer, modal, lead form
 * Source design: boxful_app/ (static mockup)
 */

// ==========================================================================
// [설정] 구글 스프레드시트 연동 URL
// 구글 스프레드시트 > 확장 프로그램 > Apps Script 배포 URL
// ==========================================================================
const GOOGLE_SHEETS_WEBAPP_URL = "https://script.google.com/macros/s/AKfycby13rkGzCVfAYMjKqPNIKNYKoql8QocIJCmY3TeMSQiChnJ7seZYcIed62Ssa2UOyE/exec";

document.addEventListener('DOMContentLoaded', () => {
  // Initialize default calculator calculation and Vietnam country selection
  calculateBestCourier();
  selectCountry('vn');

  // Close mobile drawer when clicking any anchor links inside it
  const drawerLinks = document.querySelectorAll('.mobile-drawer a');
  drawerLinks.forEach(link => {
    link.addEventListener('click', () => {
      closeMobileMenu();
    });
  });

  // Saved choice wins, otherwise fall back to the locale rendered by Laravel
  const savedLang = localStorage.getItem('boxful_lang') || window.BOXFUL_INITIAL_LANG || 'ko';
  switchLanguage(savedLang);
});

// Mobile Drawer Navigation Toggle
function toggleMobileMenu() {
  const drawer = document.getElementById('mobileDrawer');
  if (!drawer) return;
  drawer.classList.toggle('active');
  if (drawer.classList.contains('active')) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
}

function closeMobileMenu() {
  const drawer = document.getElementById('mobileDrawer');
  if (drawer) {
    drawer.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// Collapsible Form Details Toggle
function toggleFormDetails() {
  const body = document.getElementById('skuCollapseBody');
  const icon = document.getElementById('collapseIcon');
  if (!body) return;
  
  body.classList.toggle('open');
  if (icon) {
    icon.style.transform = body.classList.contains('open') ? 'rotate(180deg)' : 'rotate(0deg)';
  }
}

// Modal Functions
function openProposalModal(defaultTab = 'proposal') {
  const modal = document.getElementById('proposalModal');
  if (modal) {
    modal.style.display = 'block';
    document.body.classList.add('modal-open');
    switchModalTab(defaultTab);
  }
}

function closeProposalModal() {
  const modal = document.getElementById('proposalModal');
  if (modal) {
    modal.style.display = 'none';
    document.body.classList.remove('modal-open');
  }
}

function switchModalTab(tabName) {
  const btnProposal = document.getElementById('tabProposalBtn');
  const btnQuote = document.getElementById('tabQuoteBtn');
  const viewProposal = document.getElementById('modalViewProposal');
  const viewQuote = document.getElementById('modalViewQuote');

  if (!btnProposal || !btnQuote || !viewProposal || !viewQuote) return;

  if (tabName === 'proposal') {
    btnProposal.classList.add('active');
    btnQuote.classList.remove('active');
    viewProposal.classList.remove('hidden');
    viewQuote.classList.add('hidden');
  } else {
    btnQuote.classList.add('active');
    btnProposal.classList.remove('active');
    viewQuote.classList.remove('hidden');
    viewProposal.classList.add('hidden');
  }
}

// Close modal when clicking backdrop
window.onclick = function(event) {
  const modal = document.getElementById('proposalModal');
  if (event.target === modal) {
    closeProposalModal();
  }
};

// ==========================================================================
// Form Handler (Real-time Google Spreadsheet Submission)
// ==========================================================================
async function handleContactSubmit(event) {
  event.preventDefault();

  const submitBtn = document.getElementById('submitBtn');
  const originalBtnText = submitBtn ? submitBtn.innerHTML : '🚀 1:1 맞춤 비교견적 신청하기';

  const name = document.getElementById('cName').value.trim();
  const phone = document.getElementById('cPhone').value.trim();
  const company = document.getElementById('cCompany').value.trim();
  const email = document.getElementById('cEmail').value.trim();
  const url = document.getElementById('cUrl') ? document.getElementById('cUrl').value.trim() : '';
  const volumeSelect = document.getElementById('cVolume');
  const volume = volumeSelect ? volumeSelect.options[volumeSelect.selectedIndex].text : '';
  const category = document.getElementById('cCategory') ? document.getElementById('cCategory').value.trim() : '';
  const serviceSelect = document.getElementById('cTargetCountry');
  const targetService = serviceSelect ? serviceSelect.options[serviceSelect.selectedIndex].text : '';
  const sku = document.getElementById('cSku') ? document.getElementById('cSku').value.trim() : '';
  const packing = document.getElementById('cPacking') ? document.getElementById('cPacking').value.trim() : '';
  const message = document.getElementById('cMessage') ? document.getElementById('cMessage').value.trim() : '';

  // Generate unique Ticket ID
  const ticketId = 'BXF-' + Math.floor(100000 + Math.random() * 900000);
  const now = new Date();
  const timestamp = now.toLocaleString('ko-KR', { timeZone: 'Asia/Seoul' });

  // Payload for Google Sheets
  const payload = {
    ticketId: ticketId,
    timestamp: timestamp,
    name: name,
    phone: phone,
    company: company,
    email: email,
    url: url,
    volume: volume,
    category: category,
    targetService: targetService,
    sku: sku,
    packing: packing,
    message: message,
    lang: currentLang.toUpperCase()
  };

  // Set Loading State
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.innerHTML = `⏳ ${currentLang === 'en' ? 'Submitting to Google Sheet...' : currentLang === 'vi' ? 'Đang gửi dữ liệu...' : currentLang === 'ru' ? 'Отправка данных...' : currentLang === 'ja' ? '送信中...' : '구글 스프레드시트로 전송 중...'}`;
    submitBtn.style.opacity = '0.8';
  }

  // Attempt sending to Google Sheets Web App Webhook
  try {
    if (GOOGLE_SHEETS_WEBAPP_URL && !GOOGLE_SHEETS_WEBAPP_URL.includes('YOUR_APPS_SCRIPT_WEBAPP_URL')) {
      await fetch(GOOGLE_SHEETS_WEBAPP_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });
    } else {
      console.log('[Boxful Google Sheets Sync Simulator] Payload:', payload);
      await new Promise(r => setTimeout(r, 600));
    }
  } catch (err) {
    console.warn('[Google Sheets Sync Notice] Request sent:', err);
  } finally {
    // Restore button
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalBtnText;
      submitBtn.style.opacity = '1';
    }

    // Multilingual Alert Confirmation
    const successMsg = currentLang === 'en' ? 
      `📦 Thank you, ${name} (${company})!\n\nYour quotation request has been successfully recorded in the Boxful Google Sheet.\nTicket ID: ${ticketId}\nOur dedicated manager will contact you promptly at ${phone}.` :
      currentLang === 'vi' ?
      `📦 Cảm ơn quý khách ${name} (${company})!\n\nYêu cầu báo giá của bạn đã được ghi nhận vào Google Sheet của Boxful thành công.\nMã yêu cầu: ${ticketId}\nChuyên viên Boxful sẽ liên hệ với bạn sớm qua số ${phone}.` :
      currentLang === 'ru' ?
      `📦 Спасибо, ${name} (${company})!\n\nВаша заявка успешно записана в Google Таблицу Boxful.\nНомер заявки: ${ticketId}\nНаш специалист свяжется с вами по номеру ${phone}.` :
      currentLang === 'ja' ?
      `📦 ${company}の${name}様、Boxfulフルフィルメントへのお問い合わせを承りました。\n\nGoogleスプレッドシートへ正常に登録されました。\n受付番号: ${ticketId}\n専任マネージャーよりご連絡先（${phone}）へ迅速にご案内いたします。` :
      `📦 ${company} (${name} 담당자님), Boxful 풀필먼트 1:1 맞춤 견적 신청이 완료되었습니다!\n\n📊 구글 스프레드시트로 정상 접수되었습니다.\n접수번호: ${ticketId}\n\n담당 전문 매니저가 기재해주신 연락처(${phone})로 박스 규격별 최저가 및 WMS 맞춤 제안서를 정리하여 신속히 연락드리겠습니다.`;

    alert(successMsg);
    document.getElementById('contactForm').reset();
  }
}
